import { useEffect, useState } from "react";
import AppHeader from "@/components/app/AppHeader";
import SocialCalendarPanel from "@/components/app/SocialCalendarPanel";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { CalendarDays } from "lucide-react";

export default function SocialCalendarPage() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    api.get("/projects")
      .then(({ data }) => setProjects(data))
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail) || "Failed to load projects"));
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <AppHeader />
      <main className="px-4 md:px-8 py-8 max-w-7xl mx-auto" data-testid="social-calendar-page">
        <div className="flex items-end justify-between gap-4 flex-wrap mb-8">
          <div>
            <p className="font-mono-data text-xs uppercase tracking-widest text-muted-foreground">// social</p>
            <h1 className="font-semibold tracking-tight text-4xl md:text-5xl mt-2 flex items-center gap-3">
              <CalendarDays className="w-9 h-9" strokeWidth={1.5} /> Calendar
            </h1>
            <p className="text-sm text-muted-foreground mt-2 max-w-xl">
              One queue for every project. Schedule a post, get a reminder when it&apos;s time, copy or share with one click, mark it posted.
            </p>
          </div>
        </div>
        <SocialCalendarPanel scope="global" projects={projects} />
      </main>
    </div>
  );
}
